import React, { useContext } from 'react';
import { Toaster } from 'react-hot-toast';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { AuthContext } from '../navigation/AuthProvider';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';

export const Login = (oProps: any) => {
  const oAuthContext = useContext(AuthContext);
  const { userInfo } = useContext(AuthContext);

  const navigate = useNavigate();

  const [saveIdCheck, setSaveIdCheck] = React.useState<boolean>(false);
  const [id, setId] = React.useState<string>('');
  const [password, setPassword] = React.useState<string>('');
  const [errorBorder, setErrorBorder] = React.useState<boolean>(true);
  const [errorMessage, setErrorMessage] = React.useState<string>('');

  const init = async () => {
    let bSavedId: boolean = await AsyncLocalStorage.getItem('hotel-savedIdCheck');
    setSaveIdCheck(bSavedId);

    if (bSavedId === true) {
      let sSavedId: string = await AsyncLocalStorage.getItem('hotel-savedId');
      setId(sSavedId);
    }

    // 비밀번호 기억하기
    // let bSavedPassword: boolean = await AsyncLocalStorage.getItem('savedPasswordCheck');
    // setSavePasswordCheck(bSavedPassword);
    // if (bSavedPassword === true) {
    //   let sSavedPassword: string = await AsyncLocalStorage.getItem('savedPassword');
    //   setPassword(sSavedPassword);
    // }
  };

  const onIdChange = (e: any) => {
    setId(e.target.value);
  };

  const onPwChange = (e: any) => {
    setPassword(e.target.value);
  };

  const onSaveIdCheckbox = (e: any) => {
    setSaveIdCheck(!saveIdCheck);
  };

  // const onSavePwCheckbox = (e: any) => {
  //   setSavePasswordCheck(!savePasswordCheck);
  // };

  const onSubmit = async () => {
    if (!id) {
      setErrorMessage('올바른 계정정보를 입력해 주세요.');
      setErrorBorder(false);
      return false;
    }
    if (!password) {
      setErrorMessage('올바른 계정정보를 입력해 주세요.');
      setErrorBorder(false);
      return false;
    }

    let oRes = await oAuthContext.handleLogin(id, password, saveIdCheck /*savePasswordCheck*/);
    console.log('oRes------->', oRes);
    if (oRes && oRes.ok === false) {
      setErrorMessage('올바른 계정정보를 입력해 주세요.');
      setErrorBorder(false);
      return false;
    }
  };

  const moveForgetIdPage = () => {
    navigate('/loginIdForget');
  };
  const moveUserJoin = () => {
    navigate('/loginUserJoin');
  };

  const location = useLocation();
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirect') || '/';

  React.useEffect(() => {
    init();

    if (userInfo && location.pathname.indexOf('/sales/monthly') === -1) {
      navigate(redirectUrl === '/' ? '/sales/monthly' : redirectUrl, { replace: true });
    }
  }, []);

  return (
    <Style>
      <div className="wrap">
        <div className="container">
          <div className="header">
            <img
              className="logo"
              src={`${process.env.PUBLIC_URL}/img/knock_wide_logo.png`}
              alt="logo"
            />
            <img src={`${process.env.PUBLIC_URL}/svg/ic_login.svg`} alt="store" />
            <h5>노크노크 호텔리어</h5>
          </div>
          <div className="content">
            <div className="loginWrap">
              <div className="loginForm">
                <label htmlFor="id">아이디</label>
                <input
                  type="text"
                  name="id"
                  placeholder="아이디를 입력해 주세요."
                  value={id}
                  onChange={onIdChange}
                  style={{ border: !errorBorder ? '1px solid red' : '' }}
                />
                {!errorBorder && (
                  <div className="errorMessage">
                    <p>{errorMessage}</p>
                  </div>
                )}
              </div>
              <div className="loginForm">
                <label htmlFor="password">비밀번호</label>
                <input
                  type="password"
                  name="password"
                  placeholder="비밀번호를 입력해 주세요."
                  value={password}
                  onChange={onPwChange}
                  style={{ border: !errorBorder ? '1px solid red' : '' }}
                />
                {!errorBorder && (
                  <div className="errorMessage">
                    <p>{errorMessage}</p>
                  </div>
                )}
              </div>
            </div>
            <div className="formCheckbox">
              <label onClick={onSaveIdCheckbox}>
                <div className={`checkBox ${saveIdCheck && 'active'}`}>
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_check_bold.svg`}
                    width={14}
                    height={14}
                    alt="체크박스"
                  />
                </div>
                <h4>아이디 저장</h4>
              </label>
            </div>
            <button className="loginButton" onClick={onSubmit}>
              <p>로그인</p>
            </button>
            <button onClick={moveUserJoin}>
              <h4>회원가입</h4>
            </button>
          </div>
          <div className="footer">
            <h5>
              고객센터 <span>1670-5324</span>
            </h5>
            <p>Copyright 2023. Invisible Ideas. All rights reserved</p>
          </div>
        </div>
      </div>
      <Toaster />
    </Style>
  );
};

export const Style = styled.div`
  h4,
  h5,
  p {
    line-height: 30px;
    font-weight: 400;
    color: #a7a7a7;
  }
  h4 {
    font-size: 16px;
  }
  h5 {
    font-size: 14px;

    span {
      margin-left: 24px;
    }
  }

  .wrap {
    width: 100%;
    height: 100vh;
    height: 100dvh;
    background: #f7f7f7;
  }
  .container {
    width: 100%;
    max-width: 400px;
    padding: 3% 0 !important;
    margin: 0 auto;
    height: 100vh;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    background: none !important;
    border: none;
  }

  .content {
    width: 100%;
  }

  .header {
    padding-top: 10%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    img {
      width: fit-content;
    }
    .logo {
      width: 200px;
      margin-bottom: 40px;
    }
  }

  .loginWrap {
    width: 100%;
    padding-bottom: 10%;
  }
  .loginForm {
    position: relative;
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;

    label {
      font-size: 16px;
      line-height: 30px;
      font-weight: 500;
      color: #555;
    }
    input {
      padding: 10px 14px;
      border: 1px solid #cecece;
      border-radius: 8px;
      outline: none;
      color: #333;
    }
    input::placeholder {
      color: #cecece;
    }
  }
  .formCheckbox {
    width: 100%;
    display: flex;
    justify-content: space-between;

    label {
      display: flex;
      font-size: 16px;
      font-weight: 600;
      align-items: center;
      color: #344054;
      display: flex;
      align-items: center;
      gap: 6px;
    }
    .checkBox {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      border: 1px solid #cecece;
      background: #ffffff;
      border-radius: 3px;
      img {
        padding: 0;
      }
    }
    .checkBox.active {
      border: 1px solid #4dd2ae;
      background: #4dd2ae;
    }

    h4 {
      color: #979797;
    }
  }

  /* errorMessage */
  .errorMessage {
    position: absolute;
    bottom: 0;
    width: 100%;

    p {
      font-size: 12px;
      line-height: 20px;
      font-weight: 400;
      color: #f04438;
    }
  }

  /* 로그인 버튼 */
  .loginButton {
    width: 100%;
    margin: 12px 0 20px 0;
    padding: 9px 0;
    background: #4dd2ae;
    border-radius: 10px;
    border: none;
    outline: none;

    p {
      font-size: 20px;
      line-height: 30px;
      font-weight: 600;
      color: #fff;
    }
  }

  button {
    width: 100%;
    margin: 0 auto;
    h4 {
      color: #979797;
    }
  }

  /* footer */
  .footer {
    width: 100%;
    text-align: center;
    p {
      margin-top: 24px;
      font-size: 12px;
      line-height: 30px;
      font-weight: 400;
      color: #a7a7a7;
    }
  }

  @media (max-width: 800px) {
    .container {
      width: 100%;
      max-width: 100%;
      padding: 20px !important;
    }
  }
`;
